if (!customElements.get('cs-product-variant')) {
  customElements.define(
    'cs-product-variant',
    class CsProductVariant extends HTMLElement {
      constructor() {
        super();

        this.productVariantSelectors = '[js-product-variant-item]'
        this.csAddtocartBtnsMobile = this.closest('product-card')?.querySelectorAll('[js-quick-add-btn-mobile]')

        this.toggleButton = this.querySelector(".stitch-dropdown__toggle")
        this.menuItem = this.querySelector(".stitch-dropdown__menu")

        this.toggleButton.addEventListener("click", (event) => {
          event.stopPropagation();
          this.classList.toggle("is-open");
        });

        document.addEventListener("click", (event) => {
          if (!this.contains(event.target)) {
            this.classList.remove("is-open");
          }
        });

        this.csAddtocartBtnsMobile?.forEach(btn => {
            btn.addEventListener('click', ()=>{
                const parent = btn.closest('product-card');
                parent?.classList.add('selected')
                btn.classList.add('hidden')
            })
        })

        this.querySelectorAll(this.productVariantSelectors).forEach(productVariant => {
          productVariant.addEventListener('click', () => {
            
            const parent = productVariant.closest('product-card')
            this.classList.remove("is-open")
            const productUrl = productVariant?.dataset.productUrl;
            this.renderProduct(productUrl);
          })
        })
      }
      async renderProduct(productUrl) {
        console.log(`${location.origin}${productUrl}?view=cs-product-card`,123);
        
            try {
                const response = await fetch(`${location.origin}${productUrl}?view=cs-product-card`);   
                const html = await response.text();
                const html_ = new DOMParser().parseFromString(html, "text/html");
                const productGrid = html_.querySelector('[js-product-card-wrapper]');
               
                if (productGrid) {
                    const targetElement = this.closest('[js-product-card-wrapper]');
                    
                    if (targetElement) {
                        targetElement.replaceWith(productGrid);
                        
                        
                       if (window.innerWidth <= 750) {
                            const addToCartBtn = productGrid.querySelector('quick-add-component button');

                            const mobileBtnAjax = productGrid.querySelector("[js-quick-add-btn-mobile]");
                            const dropdownMenuAjax = productGrid.querySelector('.stitch-dropdown__menu')

                            if (addToCartBtn) addToCartBtn.click();
                            if (mobileBtnAjax) mobileBtnAjax.style.display = "none";
                            if (dropdownMenuAjax) dropdownMenuAjax.style.display = "flex";
                        }
                    }     
                }             
            } catch (error) {
                console.error('Error fetching product details:', error);
            } 
        }
    }
  )
}